import {
    createActionCreator,
    createDeltaActionType,
    createSignalAction
} from '../../../setup-react';

// ===== Signals ============================================================ //

// Leaderboard
export const FETCH_LEADERBOARD_DATA = createSignalAction(
    'draft-tracker/leaderboard',
    'FETCH_LEADERBOARD_DATA'
);
export const POLL_LEADERBOARD_DATA = createSignalAction(
    'draft-tracker/leaderboard',
    'POLL_LEADERBOARD_DATA'
);

// Nav
export const UPDATE_NAV_ITEM = createSignalAction(
    'draft-tracker/leaderboard',
    'UPDATE_NAV_ITEM'
);

// Filter
export const UPDATE_LEADERBOARD_FILTER = createSignalAction(
    'brownlow/leaderboard',
    'UPDATE_LEADERBOARD_FILTER'
);

// ===== Deltas ============================================================= //

// Leaderboard
export const SET_LEADERBOARD_DATA = createDeltaActionType(
    'draft-tracker/leaderboard',
    'SET_LEADERBOARD_DATA'
);
export const setLeaderboardData = createActionCreator(SET_LEADERBOARD_DATA);

// Leaderboard request tracking
export const SET_LEADERBOARD_DATA_REQUEST = createDeltaActionType(
    'draft-tracker/leaderboard',
    'SET_LEADERBOARD_DATA_REQUEST'
);
export const setLeaderboardDataRequest = createActionCreator(
    SET_LEADERBOARD_DATA_REQUEST
);

export const REMOVE_LEADERBOARD_DATA_REQUEST = createDeltaActionType(
    'draft-tracker/leaderboard',
    'REMOVE_LEADERBOARD_REQUEST'
);
export const removeLeaderboardDataRequest = createActionCreator(
    REMOVE_LEADERBOARD_DATA_REQUEST
);

// Nav
export const SET_NAV_ITEM = createDeltaActionType(
    'draft-tracker/leaderboard',
    'SET_NAV_ITEM'
);
export const setNavItem = createActionCreator(SET_NAV_ITEM);

// Filter
export const SET_LEADERBOARD_FILTER = createDeltaActionType(
    'brownlow/leaderboard',
    'SET_LEADERBOARD_FILTER'
);
export const setLeaderboardFilter = createActionCreator(SET_LEADERBOARD_FILTER);
